import { render, staticRenderFns } from "./commuNews.vue?vue&type=template&id=4c58a8c2"
import script from "./commuNews.vue?vue&type=script&lang=js"
export * from "./commuNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports